/* Choices session policy is intentionally lazy-loaded by choices-try-on.js.
   Keeping this asset lightweight prevents IndexedDB work during initial Safari page load. */
window.__choicesSessionPolicyDeferred = true;
